var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"back-navigation",on:{"click":_vm.backNavigation}},[_c('v-icon',{staticClass:"back-navigation__icon",attrs:{"aria-label":"Back Navigation","aria-hidden":"false"}},[_vm._v(" fas fa-chevron-left ")]),_c('span',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }